import React from 'react';
import ReactDOM from 'react-dom';
import 'react-lazy-load-image-component/src/effects/blur.css';

import './index.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
